import { motion } from "framer-motion";
import { AlertTriangle, X } from "lucide-react";
import { useState, useEffect } from "react";
export const BetaDisclaimer = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    const dismissed = localStorage.getItem("beta_disclaimer_dismissed");
    if (dismissed) {
      setIsDismissed(true);
      setIsVisible(false);
    }
  }, []);
  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem("beta_disclaimer_dismissed", "true");
  };
  if (!isVisible || isDismissed) return null;
  return <motion.div initial={{
    opacity: 0,
    y: 50
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: 50
  }} className="fixed bottom-20 md:bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-[9999]">
      <div className="bg-amber-500/10 backdrop-blur-xl border border-amber-500/30 rounded-xl p-3 shadow-lg">
        <div className="flex items-start gap-3">
          <div className="p-1.5 rounded-lg bg-amber-500/20">
            <AlertTriangle className="w-4 h-4 text-amber-400" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-amber-300 mb-0.5">Beta Version</p>
            <p className="text-[10px] text-gray-400 leading-relaxed">
              This is a beta version. You may find bugs, glitches, and errors. We're working hard to improve!
            </p>
          </div>
          <button onClick={handleDismiss} className="p-1 hover:bg-white/10 rounded-lg transition-colors shrink-0">
            <X className="text-gray-400 h-4 w-4" />
          </button>
        </div>
      </div>
    </motion.div>;
};
export default BetaDisclaimer;